import Divider from '@/components/common/Divider';
import LimitOrderForm from '@/components/form/LimitOrderForm';
import MarketOrderForm from '@/components/form/MarketOrderForm';
import OcoOrderForm from '@/components/form/OcoOrderForm';
import StopOrderForm from '@/components/form/StopOrderForm';
import { OrderPrefillValues } from '@/state/reducers/orderSlice';
import useLanguage from '@/utils/hooks/useLanguage';
import { useMediaQuery } from '@/utils/hooks/useMediaQuery';
import useOrderExecution from '@/utils/hooks/useOrderExecution';
import { Tab } from '@headlessui/react';
import cn from 'classnames';
import { useMemo } from 'react';
import Modal, { ModalClose, ModalHeader, ModalProps, ModalTab, ModalTabList, ModalTitle } from './Modal';

interface TraderOrderModalProps extends ModalProps {
    prefillValues?: OrderPrefillValues;
}

export default function TraderOrderModal(props: TraderOrderModalProps) {
    const { handlers, prefillValues } = props;

    const lang = useLanguage();
    const orderExecutionProps = useOrderExecution('trader');

    const tabs = useMemo(() => {
        return [
            lang.orderForm.marketOrder,
            lang.orderForm.limitOrder,
            lang.orderForm.stopOrder,
            lang.orderForm.ocoOrder
        ];
    }, [lang]);

    const largeHeight = useMediaQuery('(min-height: 900px)');

    return (
        <Modal {...props} size="max-w-lg">
            <div className="h-full flex flex-col">
                <ModalHeader>
                    <ModalTitle>Order Placement</ModalTitle>
                    <ModalClose handlers={handlers} />
                </ModalHeader>
                <Divider />
                <div className="flex flex-col flex-1 basis-0 h-full lg:h-auto w-full text-brand-text">
                    <Tab.Group>
                        <ModalTabList>
                            {tabs.map((tab) => (
                                <ModalTab key={tab}>{tab}</ModalTab>
                            ))}
                        </ModalTabList>
                        <Tab.Panels
                            className={cn('flex flex-1 overflow-hidden', {
                                'lg:min-h-[500px] basis-0': !largeHeight,
                                'lg:min-h-[600px]': largeHeight
                            })}>
                            <Tab.Panel className={cn('flex-1 overflow-y-auto', { 'basis-0': !largeHeight })}>
                                <MarketOrderForm
                                    {...orderExecutionProps}
                                    // prefillValues={prefillValues}
                                    onClose={handlers.close}
                                    closeOnSubmit
                                />
                            </Tab.Panel>
                            <Tab.Panel className={cn('flex-1 overflow-y-auto', { 'basis-0': !largeHeight })}>
                                <LimitOrderForm {...orderExecutionProps} onClose={handlers.close} closeOnSubmit />
                            </Tab.Panel>
                            <Tab.Panel className={cn('flex-1 overflow-y-auto', { 'basis-0': !largeHeight })}>
                                <StopOrderForm {...orderExecutionProps} onClose={handlers.close} closeOnSubmit />
                            </Tab.Panel>
                            <Tab.Panel className={cn('flex-1 overflow-y-auto', { 'basis-0': !largeHeight })}>
                                <OcoOrderForm {...orderExecutionProps} onClose={handlers.close} closeOnSubmit />
                            </Tab.Panel>
                        </Tab.Panels>
                    </Tab.Group>
                </div>
            </div>
        </Modal>
    );
}
